import React, { useState } from "react";
import { css } from "emotion";
import TabBar from "../createNew/TabBar";
import EditOptions from "./EditOptions";

const EditBodyMobile = () => {
  const [isText, setIsText] = useState(true);
  return (
    <div className={container}>
      <TabBar isText={isText} setIsText={setIsText} />
      <EditOptions isText={isText} />
    </div>
  );
};

export default EditBodyMobile;

const container = css`
  flex: 1;
`;
